import { useEffect, useRef } from "react";
import {
  FaHome,
  FaUser,
  FaSignOutAlt,
  FaMoneyBillWave,
  FaChartLine,
} from "react-icons/fa";
import { MdAccountBalanceWallet, MdSettings } from "react-icons/md";
import { RiLockPasswordLine, RiLiveLine } from "react-icons/ri";
import { BsFillFileEarmarkRuledFill } from "react-icons/bs";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { revertUser } from "../../redux/slices/userSlice";
import { revertAccount } from "../../redux/slices/accountSlice";
import { persistor } from "../../redux/store";
import { toggleRightSidebar } from "../../redux/slices/sidebarSlice";
import { History, X } from "lucide-react";
import { isSignupUser } from "../../utils/helper/commonSelectors";
import { toast } from "react-toastify";
import { ReCallCasinoBalance } from "../../api";

export default function ExposureRightNavDrawer() {
  const acctype = useSelector((state) => state.account.accountType);
  // const userData = useSelector(getUserData());
  const userData = useSelector((state) => state?.user?.userData) || {};
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.sidebar.isRightOpen);
  const sidebarRef = useRef(null);
  const signupUser = useSelector(isSignupUser());

  const mainWallet =
    userData?.availableBalance + userData?.casinoBalance - userData?.exposure;

  const handleLogout = (event) => {
    event.preventDefault();
    dispatch(revertUser());
    dispatch(revertAccount());
    localStorage.clear();
    persistor.purge();
    setTimeout(() => {
      window.location.href = "/";
    }, 300);
  };

  const closeSidebar = (event) => {
    event?.preventDefault();
    dispatch(toggleRightSidebar());
  };

  const handlereCall = async (e) => {
    e.preventDefault();
    console.log(userData?.casinoBalance);

    try {
      const response = await ReCallCasinoBalance({
        CasinoBalance: userData?.casinoBalance,
      });
      toast.success(response.data.message);
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Error occurred";
      toast.error(errorMessage);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !event.target.closest("a") &&
        !event.target.closest("button") &&
        !event.target.closest("[data-ignore-outside-click='true']")
      ) {
        closeSidebar();
      }
    };

    if (isOpen) {
      setTimeout(() => {
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
      }, 100);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.height = "100vh";
    } else {
      document.body.style.overflow = "";
      document.body.style.height = "";
    }

    return () => {
      document.body.style.overflow = "";
      document.body.style.height = "";
    };
  }, [isOpen]);

  const MenuItem = ({
    to,
    icon,
    label,
    bgColor = "border-b border-[#dcdada] text-[#2e2e2e]",
    shouldCloseSidebar = true,
  }) => {
    const textColor = ["Deposit", "Withdraw"].includes(label)
      ? "text-white"
      : "text-[#2e2e2e]";

    const handleLinkClick = (e) => {
      e?.preventDefault();
      navigate(to);
      if (shouldCloseSidebar) {
        setTimeout(() => {
          dispatch(toggleRightSidebar());
        }, 100);
      }
    };

    return (
      <li className={`items-center ${bgColor} py-2 px-4`}>
        <Link
          to={to}
          className={`flex items-center space-x-3 ${textColor}`}
          onClick={handleLinkClick}
        >
          {icon}
          <span>{label}</span>
        </Link>
      </li>
    );
  };

  return (
    <div
      ref={sidebarRef}
      className={`fixed top-[72px] right-0 h-[calc(100vh-72px)] w-[230px] bg-white text-black shadow-lg transform transition-transform duration-300 ease-in-out z-50 ${
        isOpen ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div className="p-2 relative bg-[#095771] text-center border-b border-gray-500">
        <p className="text-sm text-white">
          HI,{" "}
          <span className="notranslate">{userData?.userName || "User"}</span>
        </p>
        <button
          onClick={closeSidebar}
          className="absolute top-0.5 right-0 p-2 text-[#ddad12] hover:text-white focus:outline-none"
        >
          <X className="h-5 w-5" />
        </button>
      </div>

      <div className="text-sm text-black px-4 mt-3 pb-2 border-b border-[#dcdada]">
        <p className="font-semibold flex gap-2 text-[12px]">
          <span>Main Wallet:</span>
          <span className="text-[#daa700]">
            {userData?.availableBalance?.toFixed(0) -
              userData?.exposure?.toFixed(0) || "0"}
          </span>
        </p>
        <p className="font-semibold flex gap-2 text-[12px]">
          Bonus Balance:
          <span className="text-[#daa700]">
            {userData?.bonusBalance?.toFixed(0) || "0"}
          </span>
        </p>
        <p className="font-semibold flex gap-2 text-[12px] flex justify-between">
          <div>
            <span>Casino Wallet: </span>
            <span className="text-[#daa700]">
              {userData?.casinoBalance?.toFixed(0) || ""}
            </span>
          </div>
          {userData?.casinoBalance ? (
            <span
              className="bg-[#095771] rounded-md text-[white] px-1 cursor-pointer"
              onClick={handlereCall}
              data-ignore-outside-click="true"
            >
              Recall
            </span>
          ) : (
            ""
          )}
        </p>
        <p className="font-semibold flex gap-2 text-[12px]">
          Net Exposure:
          <span className="text-[#daa700]">
            {userData?.exposure?.toFixed(0) || "0"}
          </span>
        </p>
        <p className="font-semibold flex gap-2 text-[12px]">
          Total Balance:
          <span className="text-[#daa700]">
            {mainWallet?.toFixed(0) || "0"}
          </span>
        </p>
      </div>

      <ul className="text-sm">
        {acctype === "real" ? (
          <>
            <MenuItem
              to="/"
              icon={<FaHome />}
              label="Home"
              bgColor="bg-green-600"
            />
            {signupUser && (
              <>
                <MenuItem
                  to="/deposit"
                  icon={<FaMoneyBillWave />}
                  label="Deposit"
                  bgColor="bg-[#045121]"
                />
                <MenuItem
                  to="/withdraw"
                  icon={<FaChartLine />}
                  label="Withdraw"
                  bgColor="bg-[#910707]"
                />
              </>
            )}

            <MenuItem to="/profile" icon={<FaUser />} label="My Profile" />
            <MenuItem
              to="/profit-loss-report"
              icon={<MdAccountBalanceWallet />}
              label="Profit Loss Report"
            />
            <MenuItem
              to="/account-statement"
              icon={<HiOutlineDocumentReport />}
              label=" Account Statement"
            />
            <MenuItem
              to="#"
              icon={<BsFillFileEarmarkRuledFill />}
              label="Bonus Rules"
            />
            <MenuItem
              to="/unsettled-bet"
              icon={<RiLiveLine />}
              label="Live Bets"
            />
            <MenuItem
              to="/bet-history"
              icon={<History size={14} />}
              label="Bet History"
            />
            <MenuItem
              to="/set-stake"
              icon={<MdSettings />}
              label="Stake Settings"
            />
            <MenuItem
              to="/change-password"
              icon={<RiLockPasswordLine />}
              label="Change Password"
            />
          </>
        ) : (
          <MenuItem
            to="/"
            icon={<FaHome />}
            label="Rules"
            bgColor="bg-green-600"
          />
        )}
      </ul>

      <div className="w-full">
        <button
          onClick={handleLogout}
          className="bg-[#ff8733] text-white py-2 px-4 w-full flex items-center justify-center space-x-2 relative z-50"
        >
          <FaSignOutAlt />
          <span>SIGN OUT</span>
        </button>
      </div>
    </div>
  );
}
